<template>
    <div class='thumbnails-container'>
        <ThumbnailPlaceholders  v-show='!product.product'/>
        <div v-for='image in images' :key="image">
            <Thumbnail :image='image' @thumbnailClickListener='thumbnailClickListener'/>
        </div>
    </div>
</template>

<script>
import Thumbnail from '@/ecom/components/products/single_product/images/Thumbnail.vue';
import ThumbnailPlaceholders from '@/ecom/components/products/single_product/images/ThumbnailPlaceholders.vue';

export default {
    components: {Thumbnail, ThumbnailPlaceholders},
    props: ['product', 'images'],
    methods:{
        thumbnailClickListener(image){
            this.$emit('thumbnailClickListener', image);
        }
    }
}
</script>

<style lang="scss" scoped>

.thumbnails-container{
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media(max-width: 970px){
        flex-direction: row;
        flex-wrap: wrap;
        order: 1; //Swap thumbnails to go underneath main image
    }
}

</style>